import logReport from '@/util/logReport';
import apiEvent from '@/util/call/apiEvent';
import eventBus from '@/EventBus';
import initNeoWebRtc from '@/util/call/neoWebRTC/initNeoWebRtc';
import netDialAPI from '@/util/call/neoWebRTC/neoWebRtcAPI/neoWebRtcAPI';

const getDefaultState = () => {
  return {
    toastedInfo: []
  };
};

const state = getDefaultState();

const getters = {};

const mutations = {
  ADD_TOASTED_INFO(state, payload) {
    state.toastedInfo = [...state.toastedInfo, payload];
  },
  REMOVE_TOASTED_INFO(state) {
    if (state.toastedInfo.length > 0) {
      state.toastedInfo.forEach((toastObj, index) => {
        if (toastObj.goAway) {
          toastObj.goAway(0);
        }
        state.toastedInfo.splice(index, 1);
      });
    }
  }
};

const checkIsWebsocketConnectAvailable = ({ rootState, rootGetters }) => {
  const { isCallSocketConnected, isCallConnecting } = rootState.callWebsocket;
  const { callWebsocketUrl } = rootState.callServer;
  const { enabledCallAgent, isExistCallAgent, telNumber } = rootGetters;

  if (isCallSocketConnected) return false; // 이미 콜 서버에 연결되어 있으면
  if (isCallConnecting && !isCallSocketConnected) return false; // 콜 서버에 연결 시도중일 때
  if (!callWebsocketUrl) return false; // 연결할 콜 웹소켓 url이 없으면

  if (!isExistCallAgent) return false; // 존재하지 않는 콜 상담사 계정이면
  if (!enabledCallAgent) return false; // 사용 승인된 콜 상담사 계정이 아니면
  if (!telNumber) return false; // 내선번호가 없으면

  return true;
};

const connectWithValidation = ({ commit, dispatch, rootState }) => {
  const { isFirstConnect } = rootState.callWebsocketReconnect;
  const { callWebsocketUrl } = rootState.callServer;

  if (!isFirstConnect) {
    commit('changeCallWebSocketUrl', { root: true });
    commit('setIsCallSocketReConnected', true, { root: true });
  }

  commit('START_CALL_CONNECT', null, { root: true });

  if (!isFirstConnect) {
    dispatch('notifySocketReconnection');
  } else {
    commit('setIsFirstConnect', false, { root: true });
  }

  let stompClient = new WebSocket(callWebsocketUrl);
  stompClient.binaryType = 'arraybuffer';
  commit('setSocketClient', stompClient, { root: true });
};

const actions = {
  neo_web_rtc_connect({ commit, dispatch, rootState, rootGetters }) {
    const check = checkIsWebsocketConnectAvailable({ commit, rootState, rootGetters });
    if (!check) return;

    connectWithValidation({ commit, dispatch, rootState });

    rootGetters.stompClient.onopen = function () {
      initNeoWebRtc.resetCount('call');
      dispatch('notifySocketReconnectionSuccess');
      logReport.write('[SOCKET] - OPEN');
      commit('END_CALL_CONNECT', null, { root: true });
      commit('OPEN_CALL', null, { root: true });
      commit('initDimmed', null, { root: true });
      commit('CLEAR_FETCH_CALL_AGENT_LIST_INTERVAL', null, { root: true });
      commit('FETCH_CALL_AGENT_LIST', null, { root: true });
    };

    rootGetters.stompClient.onmessage = function (e) {
      if (rootGetters.IS_OVER_LAP) {
        commit('setIsOverlap', false, { root: true });
        commit('initDimmed', { root: true });
      }

      if (rootGetters.isCallSocketReConnected) {
        commit('setIsCallSocketConnected', true, { root: true });
        commit('setIsCallSocketReConnected', false, { root: true });
        commit('initDimmed', { root: true });
        logReport.write('[SOCKET] - isCallSocketReConnected');
      }

      const rcvData = new Uint8Array(e.data); // BINARY DATA BUFFER
      apiEvent.EventProc(rcvData); // SAVE EVENT STRUCT
    };

    rootGetters.stompClient.onclose = function (event) {
      dispatch('notifySocketReconnectionFail');
      commit('CLEAR_FETCH_CALL_AGENT_LIST_INTERVAL', { root: true });
      logReport.write('[SOCKET] - CLOSE >', 'code: ', event.code, 'reason:', event.reason, 'wasClean:', event.wasClean);
      commit('FAIL_CALL_CONNECT', { root: true });
      eventBus.$emit('call-reconnect-start');
      netDialAPI.initIsLogin();
      commit('initDimmed', { root: true });
    };

    rootGetters.stompClient.onerror = function (event) {
      logReport.write('[SOCKET] - ERROR');
      console.log(event);
      commit('CLEAR_FETCH_CALL_AGENT_LIST_INTERVAL', { root: true });
      commit('initDimmed', null, { root: true });
    };
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/callWebsocket/neoWebRtcWebsocket.js